<script lang="ts">
  import Header from "./components/Header.svelte";
  import Home from "./components/Home.svelte";
  import Products from "./components/Products.svelte";
  import AboutUs from "./components/AboutUs.svelte";
  import ContactUs from "./components/ContactUs.svelte";
  import Admin from "./components/Admin.svelte";
  import Orders from "./components/Orders.svelte";
  import Footer from "./components/Footer.svelte";

  import { currentRoute } from "./store";
</script>

<Header />
<main class="my-20">
  {#if $currentRoute === "Home"}
    <Home />
  {:else if $currentRoute === "Products"}
    <Products />
  {:else if $currentRoute === "Orders"}
    <Orders />
  {:else if $currentRoute === "About Us"}
    <AboutUs />
  {:else if $currentRoute === "Contact Us"}
    <ContactUs />
  {:else if $currentRoute === "Admin"}
    <Admin />
  {/if}
</main>
<Footer />
